import { FC, useRef, useState } from "react";

import InputError from "../../styles/input/InputError.styled";
import InputLabel from "../../styles/input/InputLabel.styled";
import { StyledInput } from "./styles/StyledInput.styled";
import { StyledTextInputContainer } from "./styles/StyledTextInputContainer.styled";
import StyledTextInput from "./styles/StyledTextInput.styled";

interface TextInputProps {
  id: string;
  label?: string;
  error: string | null;
  onChange: (value: string) => void;
  onFocus?: () => void;
  maxLength?: number;
  disabled?: boolean;
  placeholder?: string;
  value: string;
}

export const TextInput: FC<TextInputProps> = ({
  id,
  label,
  disabled,
  value,
  error,
  maxLength,
  onChange,
  onFocus,
  placeholder,
}) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const onContainerClick = () => {
    inputRef.current?.focus();
  };

  return (
    <StyledTextInputContainer id={id}>
      <StyledTextInput
        onClick={onContainerClick}
        focused={focused}
        error={error}
        disabled={disabled}
      >
        {label && <InputLabel>{label}</InputLabel>}
        <StyledInput
          aria-label={label}
          ref={inputRef}
          disabled={disabled}
          value={value}
          maxLength={maxLength}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => {
            setFocused(true);
            onFocus?.();
          }}
          placeholder={placeholder}
          onBlur={() => setFocused(false)}
        />
      </StyledTextInput>
      {error ? <InputError>{error}</InputError> : null}
    </StyledTextInputContainer>
  );
};
